/**
 * This is the terms condition controller.
 * @memberOf terms condition Module
 * @namespace terms condition Controller
 */

/**
 * @name termscondController
 * @desc Create the controller.
 * @param $scope
 * @param $translate
 * @param coreService
 * @param $sce
 * @memberOf terms condition Module.terms condition Controller
 * @ngInject
 */
function termscondController($scope, $translate, coreService, $sce) {

    // Assign this controller as the view-model.
    // It will be accessible as 'termscondController' within the HTML template.
    var vm = this;

    // Register the view model's properties.
    vm.validateForm = validateForm;
    vm.submitted = false;
    vm.success = false;
    vm.messages = [];
    vm.accepted = 0;
    $scope.$destroy = destroy;
    $scope.terms = displayTerms;
    $scope.getSafeUrl = getSafeUrl;
    // Activate the controller.
    activate();

    // Activates the controller.
    function activate() {

        // Read Identity Server's data model
        var model = coreService.getIdentityModel();

        // Change display language
        if (model.ui_locales) {
            $translate.use(model.ui_locales);
        }

        $scope.model = model;
    }

    function destroy () {
    };

    function displayTerms(){
          return $sce.trustAsHtml($scope.model.terms);
    };

    function getSafeUrl(url){
        return $sce.trustAsResourceUrl(url);
    };

    // Validate the form.
    function validateForm(e) {
        // Update the form.
        vm.messages = [];
        vm.submitted = true;
    }
}

export default termscondController;



// WEBPACK FOOTER //
// ./src/login/termscond/termscond.controller.js